import React, { useState, useMemo } from "react";
import { Box, TablePagination } from "@mui/material";
import { Search } from "@tiny/icons";
import { Theme } from "@mui/material";
import { TableHeaderCellsTypes } from "../../../components/Table/table.types";
import { EmptyState, Panel } from "../../../components";
import TinyTable from "../../../components/Table";
import { ContactHistoryTableProps } from "./ContactHistoryTable.types";
import { useContactHistoryTable } from "./ContactHistoryTable.hooks";
import { headerCells } from "./ContactHistoryTable.helpers";

function ContactHistoryTable({ filters }: ContactHistoryTableProps) {
  const {
    handleSort,
    handleChangeRowsPerPage,
    handleChangePage,
    tableRows,
    isLoading,
    totalElements,
    currentSort,
    page,
    rowsPerPage,
  } = useContactHistoryTable({ filters });
  const renderEmptyState = () => (
    <EmptyState
      Icon={
        <Search
          sx={(theme: Theme) => ({
            color: "grey.80",
            width: theme.spacing(6),
            height: theme.spacing(6),
          })}
        />
      }
      title="No daily stats available"
      message="Daily statistics will appear here once email campaigns are sent"
    />
  );

  return (
    <Panel title="Detailed Daily Stats">
      <Box sx={{ width: "100%" }} mt={6}>
        {tableRows.length === 0 && !isLoading ? (
          renderEmptyState()
        ) : (
          <>
            <TinyTable
              headerCells={headerCells}
              rowsData={tableRows}
              rows={tableRows}
              options={{
                currentSort: "email,asc",
                onSort: handleSort,
                showActionAlways: false,
                showBorders: true,
              }}
            />

            {totalElements > 0 && (
              <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
                <TablePagination
                  component="div"
                  count={totalElements}
                  page={page}
                  onPageChange={handleChangePage}
                  rowsPerPage={rowsPerPage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                  rowsPerPageOptions={[5, 10, 25, 50]}
                  labelRowsPerPage="Rows per page:"
                  labelDisplayedRows={({ from, to, count }) =>
                    `${from}-${to} of ${
                      count !== -1 ? count : `more than ${to}`
                    }`
                  }
                />
              </Box>
            )}
          </>
        )}
      </Box>
    </Panel>
  );
}

export default ContactHistoryTable;
